import { Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { FacturaService } from '../services/factures-service/factures.service';
import { resumeDataInterface } from '../interfaces/resume';
import { FacturesListComponent } from './factures-list/factures-list.component';
import { saveAs } from 'file-saver';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface IRequestOfRows {
  limit: number;
  skip: number;
  filters: any;
  conds: any;
  ordering: any;
  export: boolean;
}

class BaseFacturaCercadorComponent {
  public elementList: {'offset':0, 'registers':0, 'rows': Array<any>};
  public resumeData: resumeDataInterface = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};

  public sendRows(req: IRequestOfRows) {
    this.requestService.getActive(req.limit, req.skip, req.filters, req.conds, req.ordering)
      .subscribe(
        elements => {
          this.elementList = elements;
          this.resumeData = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
           empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
           this.elementList.rows.map(item => {
              if(item.empresa != "Consorci")
                switch(item.ambit_proposta){
                  case 'Europa': this.resumeData.ambit.totalEU+=item.facturacio_prevista_eur;this.resumeData.ambit.numEU++;break;
                  case 'Internacional': this.resumeData.ambit.totalInt+=item.facturacio_prevista_eur;this.resumeData.ambit.numInt++;break;
                  case 'Espanya': this.resumeData.ambit.totalE+=item.facturacio_prevista_eur;this.resumeData.ambit.numE++;break;
                  case 'Catalunya': this.resumeData.ambit.totalCAT+=item.facturacio_prevista_eur;this.resumeData.ambit.numCAT++;break;
                };
              switch(item.empresa){
                case 'MCRIT': this.resumeData.empresa.totalMCRIT+=item.facturacio_prevista_eur;this.resumeData.empresa.numMCRIT++;break;
                case 'Multicriteri': this.resumeData.empresa.totalMULTI+=item.facturacio_prevista_eur;this.resumeData.empresa.numMULTI++;break;
                case 'Multicriteri MCRIT AIE': this.resumeData.empresa.totalAIEMULTI+=item.facturacio_prevista_eur;this.resumeData.empresa.numAIEMULTI++;break;
                case 'Ersília': this.resumeData.empresa.totalERSI+=item.facturacio_prevista_eur;this.resumeData.empresa.numERSI++;break;
                case 'Geovincles': this.resumeData.empresa.totalGEO+=item.facturacio_prevista_eur;this.resumeData.empresa.numGEO++;break;
              }
          });
          if(req.export){
            var csvData = this.convertToCSV(this.elementList.rows);
            var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }
        },
        error => console.log(error)
      );
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private requestService: FacturaService) {}
}

@Component({
  selector: 'mcrit-gestio-factures-cercador',
  template: `
    <mcrit-gestio-factures-list
      (requestRows)="sendRows($event)"
      [resumeData]="resumeData"
      [elementList]="elementList">
    </mcrit-gestio-factures-list>`,
  styleUrls: ['factures-cercador.component.css'],
  providers: [  ]
})

export class FacturaCercadorComponent extends BaseFacturaCercadorComponent {
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(public translate: TranslateService, public languageService: LanguageService, facturaService: FacturaService) {
    super(translate, languageService, facturaService);
  }

  ngOnInit(){
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
 
}
